// initial state
import api from '../api';

const state = {
  user: {},
  toastr: null,
};

// getters
const getters = {
  user: state => state.user || {},
  userNodeId: (_, getters) => getters.user.userNodeId,
  idToken: state => state.user?.idToken,
  isLoggedIn: state => !!state.user.idToken,
  isAdmin: state => state.user.type === 'ADMIN',
  toastr: state => state.toastr,
};

// actions
const actions = {
  login({ commit }) {
    return api
      .gql({
        query: `query me {
        me {
          id
          name
          type
        }
      }`,
      })
      .then(({ me: user }) => {
        commit('login', user);
      });
  },
};

// mutations
const mutations = {
  toastr(state, payload) {
    state.toastr = payload;
  },
  user(state, payload) {
    state.user = payload;
  },
  login(state, payload) {
    const user = (state.user = { ...state.user, type: payload.type, userNodeId: payload.id });
    window.localStorage.setItem('lecle-reviews-current-user', btoa(JSON.stringify(user)));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
